import { render } from "./Loading.vue?vue&type=template&id=0ca20bb2&scoped=true"
import script from "./Loading.vue?vue&type=script&lang=js"
export * from "./Loading.vue?vue&type=script&lang=js"

import "./Loading.vue?vue&type=style&index=0&id=0ca20bb2&lang=css"
import "./Loading.vue?vue&type=style&index=1&id=0ca20bb2&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ca20bb2"]])

export default __exports__